import Vue from 'vue'
import Vuex from 'vuex'
import http from '../../httpuntil'
Vue.use(Vuex)
// initial state
const state = {
  activities: [],
}

const getters = {
    // products: state => {
    //     return state.products;
    // },
    // categories: state => {
    //     return state.categories;
    // }
}
// actions
const actions = {
  getActivityList ({commit},filter) {
      console.log(filter)
      debugger
      http.post("/api/activity/list",filter,(data)=>{
        if (data.Success) {
          commit('setActivityList',data.Data.Results);
        }
      },(e)=>{
        console.log(e);
      });
  },
}
// mutations
const mutations = {
  setActivityList (state, activities) {
    //  state.videos=state.videos.concat(videos);
     state.activities=activities;
  },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
